export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; action?: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'violations',
      displayName: 'menu.violations',
      meta: {
        icon: 'report',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'system-logs',
      displayName: 'menu.systemLogs',
      meta: {
        icon: 'history',
      },
    },

    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
   
  ] as INavigationRoute[],
}
